import type { RouteRecordRaw } from 'vue-router';

export const constantRoutes: RouteRecordRaw[] = [
  { path: '/login', name: 'Login', component: () => import('@/views/login/index.vue'), meta: { hidden: true, title: 'menu.login' } },
  { path: '/forgot-password', name: 'ForgotPassword', component: () => import('@/views/forgot-password/index.vue'), meta: { hidden: true, title: 'menu.forgotPassword' } },
  { path: '/reset-password', name: 'ResetPassword', component: () => import('@/views/reset-password/index.vue'), meta: { hidden: true, title: 'menu.resetPassword' } },
  { path: '/404', name: '404', component: () => import('@/views/error/404.vue'), meta: { hidden: true, title: 'menu.error404' } },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    component: () => import('@/views/terms-of-service/index.vue'),
    meta: { title: 'menu.termsOfService', icon: 'Document'}
  },
  {
    path: '/terms-of-service-agent',
    name: 'TermsOfServiceAgent',
    component: () => import('@/views/terms-of-service/agent-service.vue'),
    meta: { title: 'menu.termsOfService', icon: 'Document'}
  },
];
